import { createApi, retry } from "@reduxjs/toolkit/query/react";
import { createFlatBufferBaseQuery } from "../../flatbuffers/api/flatBufferBaseQuery";

const maxRetries = 2;

const baseQuery = retry(
  createFlatBufferBaseQuery(process.env.REACT_APP_LIFT_NET_CLOUD_API_ONLINE ?? ""),
  { maxRetries },
);

export const permissionAPI = createApi({
  reducerPath: "permissionAPI",
  baseQuery,
  keepUnusedDataFor: 0,
  tagTypes: ["tagGetPermissions", "tagGetRole"],
  refetchOnMountOrArgChange: true,
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    //* *********************************************************** */
    //* GET ALL PERMISSIONS  */
    getPermissions: builder.query({
      query: (body: any) => ({
        url: `/permissions/?&page=${body.page}&limit=${body.limit}`,
        headers: { authorization: body.token },
      }),
      providesTags: ["tagGetPermissions"],
    }),
    //* *********************************************************** */
    //* GET PERMISSION  */
    getPermission: builder.query({
      query: (body: any) => ({
        url: `/permissions/${body.id}`,
        headers: { authorization: body.token },
      }),
      providesTags: ["tagGetPermissions"],
    }),
    //* *********************************************************** */
    //* GET PERMISSIONS BY ROLE  */
    getPermissionsByRole: builder.query({
      query: (body: any) => ({
        url: `/permissions/by-role/${body.id}`,
        headers: { authorization: body.token },
      }),
      providesTags: [],
    }),
    //* *********************************************************** */
    //* GET ROLE */
    getRole: builder.query({
      query: (body: any) => ({
        url: `/roles/${body.id}`,
        headers: { authorization: body.token },
      }),
      providesTags: ["tagGetRole"],
    }),
    //* *********************************************************** */
    //* POST PERMISSION  */
    postPermission: builder.mutation({
      query: (body: any) => ({
        url: `/permissions/`,
        method: "POST",
        body: body.body,
        headers: { authorization: body.token },
      }),
      invalidatesTags: ["tagGetPermissions"],
    }),
    //* *********************************************************** */
    //* PUT PERMISSION  */
    putPermission: builder.mutation({
      query: (body: any) => ({
        url: `/permissions/${body.id}`,
        method: "PUT",
        body: body.body,
        headers: { authorization: body.token },
      }),
      invalidatesTags: ["tagGetPermissions"],
    }),
    //* *********************************************************** */
    //* DELETE PERMISSION  */
    deletePermission: builder.mutation({
      query: (body: any) => ({
        url: `/permissions/${body.id}`,
        method: "DELETE",
        headers: { authorization: body.token },
      }),
      invalidatesTags: ["tagGetPermissions"],
    }), //* *********************************************************** */
    //* POST ASSIGN PERMISSION  */
    postAssignPermission: builder.mutation({
      query: (body: any) => ({
        url: `/permissions/assign/`,
        method: "POST",
        body: body.body,
        headers: { authorization: body.token },
      }),
      invalidatesTags: ["tagGetRole"],
    }),
    //* *********************************************************** */
  }),
});

export const {
  useLazyGetPermissionsQuery,
  useLazyGetPermissionQuery,
  useLazyGetPermissionsByRoleQuery,
  useLazyGetRoleQuery,
  usePostPermissionMutation,
  usePutPermissionMutation,
  useDeletePermissionMutation,
  usePostAssignPermissionMutation,
} = permissionAPI;
